import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import Text from "../../../../../shared/components/Text";
import { useTranslation } from "../../../../../../utils/hooks/useTranslation";

export const Field = ({
  name,
  as: Component,
  forceEnable = false,
  placeholder,
  error,
  label,
  completedProps,
  hidden = false,
  rules,
  ...rest
}) => {
  const { control } = useFormContext();
  const { getTextIdTranslation } = useTranslation();

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={(props) => {
          return (
            <>
              {React.cloneElement(Component, {
                ...props,
                fullWidth: true,
                error: !!error,
                helperText: error?.message,
                label: label && <Text tId={label} />,
                placeholder,
                InputProps: {
                  ...props.InputProps,
                },
                inputProps: {
                  "aria-label": getTextIdTranslation(label) ?? label,
                  ...props.inputProps,
                },
                style: {
                  ...rest.style,
                  display: hidden ? "none" : "block",
                },
                ...rest,
              })}
            </>
          );
        }}
      />
    </div>
  );
};
